//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/RoutingCommon.js";
import "../no/Builder.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../RoutingCommon/RoutingCommon.CornerBuilder.js";
import "../no/NXObject.js";
import "../no/Routing.js";
let d=[[[1,"ControlPointSelection",0,"Routing.RouteObjectCollector",0],[1,"CornerSettings",0,"RoutingCommon.CornerBuilder",0]],[[["num_components"],"GetCreatedComponents",{R_:{components:"Assemblies.Component[]"}},0,0],[[],"PreCommit",{},0,0],[["nObjects","logicalObjects"],"GetLogicalObjects",{},0,0],[["nAttributes","attributes"],"GetBendCornerAttributes",{},0,0],[["attributes"],"SetBendCornerAttributes",{},1,0],[["corners"],"RemoveBendCornerAttributes",{},1,0],[[],"PopulateExtendTrimStockMap",{},0,0],[[],"CycleSolution",{},0,0]],[]];
SPLM.RoutingCommon.AssignCornerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.RoutingCommon.AssignCornerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;